module.exports = __webpack_public_path__ + "static/media/refresh.0962bb48.svg";